import { Controller } from 'stimulus';
import * as $ from 'jquery';
import { fetch } from 'whatwg-fetch';

/**
 * 指定された URL を読み込み、結果で target を置き換える。
 *
 * パラメータ
 * url 読み込む URL
 * trigger 読み込みを開始するイベント. 指定がないときは自動で読み込む
 * loaded 読み込み終了フラグ. 存在する場合 URL の読み込みを行なわない
 *
 * ターゲット
 * target 読み込んだ結果で置換する
 * spinner スピナー 読み込み中は表示状態になる
 */
export default class extends Controller {
  static targets = ['spinner', 'target'];

  initialize() {
    this.load = this.load.bind(this);
  }

  connect() {
    if (this.trigger) {
      $(this.element).on(this.trigger, this.load);
    } else {
      this.load();
    }
  }

  disconnect() {
    if (this.trigger) {
      $(this.element).off(this.trigger, this.load);
    }
  }

  load() {
    if (this.loaded) return;

    this.showSpinner();

    fetch(this.url)
      .then(response => {
        if (response.status >= 200 && response.status < 300) {
          return response.text();
        } else {
          const error = new Error(response.statusText);
          error.response = response;
          throw error;
        }
      })
      .then(data => {
        this.targetTarget.innerHTML = data;
        this.loaded = true;
      })
      .catch(error => {
        alert(error);
      })
      .finally(() => {
        this.hideSpinner();
      });
  }

  hideSpinner() {
    $(this.spinnerTarget).hide();
  }

  showSpinner() {
    $(this.spinnerTarget).show();
  }

  get trigger() {
    return this.data.get('trigger');
  }

  get url() {
    return this.data.get('url');
  }

  get loaded() {
    return this.data.has('loaded');
  }

  set loaded(loaded) {
    if (loaded) {
      this.data.set('loaded', '1');
    } else {
      this.data.delete('loaded');
    }
  }
}
